import React, { useState,useEffect } from 'react';
import {useAppDispatch,useAppSelector} from '@/store/hooks';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { Modal,Form, Input,App, Row, Col, Select,Table, Button } from 'antd';
import { eventBus } from '@/utils/eventBus';
import styles from './EngineerZone.module.scss';
import checkIcon from '@/assets/images/路径 1639@2x.png';
import { saveUserInfo } from '@/api/user';
import CookieUtil from '@/utils/cookies';
import { setUserInfo,setEngineerZoneInfo } from '@/store/slices/userSlice';
import { useTranslation } from 'react-i18next';
interface IForm {
  email:string; //邮箱
  phone:string; //手机号
};

const { Option } = Select;
const LicenseList = [
  { label: 'PE许可证', value: '1' },
]
const PayoutAccountTypeList = [
  { label: 'Bank Account', value: '1' },
  { label: 'Payment Processor', value: '2' },
]
const BankNameList = [
  { label: 'Bank of America', value: '1' },
]
const EngineerZone: React.FC = () => {

  const {message} = App.useApp();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  // 列表数据
  const [dataSource, setDataSource] = useState<any[]>([
  ]);
  const userInfo = useAppSelector((state) => state.user.userInfo);
  const engineerZoneInfo = useAppSelector((state) => state.user.engineerZoneInfo);
  const columns = [
    {
      title: 'name',
      dataIndex: 'Name',
      key: 'Name',
      align: 'center' as const,
    },
    {
      title: 'license number',
      dataIndex: 'LicenseNumber',
      key: 'LicenseNumber',
      align: 'center' as const,
    },
    {
      title: 'addrsss',
      dataIndex: 'city',
      key: 'city',
      align: 'center' as const,
    },
    {
      title: 'State',
      dataIndex: 'State',
      key: 'State',
      align: 'center' as const,
    },
    {
      title: 'license type',
      dataIndex: 'LicenseType',
      key: 'LicenseType',
      align: 'center' as const,
    },
    {
      title: 'Email',
      dataIndex: 'Email',
      key: 'Email',
      align: 'center' as const,
    },
    {
      title: 'phone',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center' as const,
    },
    {
      title: 'Action',
      key: '',
      minWidth: 140,
      align: 'center' as const,
      render: (_: any, record: any, index: number) => (
          <div
            className={styles['edit']}
            onClick={() => handelTableEdit(record)}
          >edit</div>
      ),
    },
  ];
  //yourTownloopSearchValue关键字
  const yourTownloopSearchValue = useAppSelector((state)=>state.searchBar.yourTownloopSearchValue);
  
  // 修改邮件地址的模态框

  //useState和Ant Design 的 Form 组件关联起来需要用到Form.useForm()
  const [form] = Form.useForm();
  const [modalForm] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [payoutAccountType, setPayoutAccountType] = useState('');
  const [PaymentMethodList, setPaymentMethodList] = useState<any[]>([
  ]);
  // Select 的 onChange 事件
  const handleSelectChange = (value: any) => {
    setPayoutAccountType(value);
    console.log('Select 选中的值:', value);
    
    // 如果需要同时更新表单值
    form.setFieldsValue({ PayoutAccountType: value });
  };

  //表单数据
  const [submitFlag, setSubmitFlag] = useState(false);
  const [editFlag, setEditFlag] = useState(true);
  //提交表单
  const handleOk = () => {
    modalForm
    .validateFields()
    .then(values => {
      console.log(values,'values');   
      // setDataSource([values])
      setDataSource(prev => [...prev, values]); 
      setIsModalOpen(false);
      saveUserInfo(values).then((res)=>{
        if(res.code == 200){
          setIsModalOpen(false);
          message.success('Update Success');

          const userInfo = CookieUtil.get('userInfo');
          if(!!userInfo){
            userInfo.phone = values.phone;
            CookieUtil.set('userInfo', userInfo);
            dispatch(setUserInfo(userInfo));
          }

        }
        
      });
    },()=>{
    });
  };
  const handelSubmit = () => { 
    console.log('submitFlag',form.getFieldValue,form,form.getFieldsValue());
    dispatch(setEngineerZoneInfo(form.getFieldsValue()));
    setSubmitFlag(true)
    setEditFlag(false)
  };

  const handelPaymentEdit = () => { 
    setEditFlag(true)
    setSubmitFlag(true)
  };
  const handelReset = () => {
    form.setFieldsValue({
      PayoutAccountType: '',
      PaymentMethod: '',
      AccountName: '',
      AccountNumber: '',
      RoutingNumber: '',
      BankName: '',
    });
  };
  const handelCancel = () => { 
    form.setFieldsValue(engineerZoneInfo)
    console.log('cancel',engineerZoneInfo);
    setSubmitFlag(true)
    setEditFlag(false)
  };
  //取消表单
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const AddInformation = () => { 
    modalForm.resetFields()
    setIsModalOpen(true)
  }
  const handelTableEdit = (record:any) => {
    console.log('record',record);
    modalForm.setFieldsValue({
      Building: record?.Building || '',
      Email: record?.Email || '',
      LicenseNumber: record?.LicenseNumber || '',
      LicenseType: record?.LicenseType || '',
      Name: record?.Name || '',
      State: record?.State || '',
      city: record?.city || '',
      phone: record?.phone || '',
    });
   setIsModalOpen(true);
  }
  const SignUpNow = () => {
   setIsModalOpen(true);
  }
  //mounted 和unmounted
  useEffect(()=>{
    return ()=>{
      console.log('组件销毁时');
      //销毁清除townloopSearchValue的值
      // eventBus.emit('deleteTownloopSearchValue');
      // dispatch(clearYourTownloopSearchValue());
    }
  },[]);
  useEffect(()=>{
    console.log('Selected Payout Account Type:', payoutAccountType);
    let list:any = []
    if(payoutAccountType === '1'){
      list = [
        {
          value: '1',
          label: 'Checking',
        },
        {
          value: '2',
          label: 'Savings',
        },
      ]
    }else{
      list = [
        {
          value: '1',
          label: 'PayPal',
        },
        {
          value: '2',
          label: 'Stripe',
        },
        {
          value: '3',
          label: 'Payoneer',
        },
        {
          value: '4',
          label: 'Square',
        },
      ]
    }
    setPaymentMethodList(list)
  },[payoutAccountType]);

  //yourTownloopSearchValue关键字的监听
  useEffect(()=>{
    console.log('AccountSecurity组件yourTownloopSearchValue',yourTownloopSearchValue);
    
   },[yourTownloopSearchValue])

  return (
    <div className={styles['account-box']}>

      <div className={styles['base-info']}> 
        <div className={styles['base-title']}>{t("YourTownLoop.EngineerZone")}</div>
      </div>
      {!dataSource.length ? (
      <div className={styles['security-box']}>
        <div className={styles['security-title']}>{t("YourTownLoop.registration")}</div>
        <div className={styles['security-list']}>
            <div 
              className={styles['security-action']}
              onClick={SignUpNow}
            >{t("YourTownLoop.SignUpNow")}</div>
        </div>
      </div>
      ) : (
        <div className={styles['service-info']}>
          <div className={styles['service-title']}>Service Information</div>
          <div className={styles['service-detail']}>
            <span>Provide accurate details to ensure seamless participation in bidding.</span>
            <span className={styles['add-information']}>
              <Button type="primary" onClick={AddInformation}>Add Verification Information</Button>
            </span>
          </div>
          <Table
            className={styles['engineer-table']}
            dataSource={dataSource}
            columns={columns}
            rowKey="id"
            pagination={false}
            bordered
          />
          <div className={styles['service-bot']}>
            <div className={styles['service-bot-title']}>
              <span>Please provide accurate payment details to ensure smooth settlement after service completion.</span>
              {submitFlag && <Button className={styles['service-edit']} onClick={handelPaymentEdit}>edit</Button>}
              </div>
            <Form form={form} layout="vertical">
              <Row gutter={16}>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item            
                                
                  >                   
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item
                    label="*Payout Account Type"
                    name="PayoutAccountType"
                    rules={[{ required: true, message: 'Please input your Payout Account Type!' }]}
                  >
                    <Select 
                      placeholder={t('membershipChild.UrgencyLevel')}
                      allowClear
                      onChange={handleSelectChange}
                      disabled={!editFlag}
                    >
                      {PayoutAccountTypeList.map((item, index) => (
                        <Option key={index} value={item.value}>{item.label}</Option>
                    ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item
                    label="*Payment Method"
                    name="PaymentMethod"
                    rules={[{ required: true, message: 'Please input your Payment Method!' }]}
                  >
                    <Select 
                      placeholder={t('membershipChild.UrgencyLevel')}
                      allowClear
                      disabled={!editFlag}
                    >
                      {PaymentMethodList.map((item, index) => (
                        <Option key={index} value={item.value}>{item.label}</Option>
                    ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item
                    label="*Account Name"
                    name="AccountName"
                    rules={[{ required: true, message: 'Please input your *Account Name!' }]}
                  >
                    <Input disabled={!editFlag}/>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item            
                  >
                  
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item
                    label="*Account Number"
                    name="AccountNumber"
                    rules={[{ required: true, message: 'Please input your Account Number!' }]}
                  >
                    <Input disabled={!editFlag}/>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item
                    label="*Routing Number / ABA"
                    name="RoutingNumber"
                    rules={[{ required: true, message: 'Please input your License Apt,Routing Number / ABA!' }]}
                  >
                    <Input disabled={!editFlag}/>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6}>
                  <Form.Item            
                    label="*Bank Name"
                    name="BankName"
                    rules={[{ required: true, message: 'Please input your Bank Name!' }]}
                  >
                    <Select 
                      placeholder={t('membershipChild.UrgencyLevel')}
                      allowClear
                      disabled={!editFlag}
                    >
                      {BankNameList.map((item, index) => (
                        <Option key={index} value={item.value}>{item.label}</Option>
                    ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              {editFlag && (
                <Form.Item  
                  className={styles['form-submit']}        
                >                  
                  {submitFlag?<Button className={styles['form-btn']} onClick={handelCancel}>cancel</Button>
                  :<Button className={styles['form-btn']} onClick={handelReset}>Reset</Button>}
                  <Button type="primary" className={styles['form-btn']} onClick={handelSubmit}>submit</Button>
                </Form.Item>
              )}    
        </Form>
          </div>
        </div>
      )}
      {/* 修改邮箱或手机号 */}
      <Modal 
        width={920}
        title="Add Verification Information"
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form form={modalForm} layout="vertical">
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item            
                label="*Name"
                name="Name"
                rules={[{ required: true, message: 'Please input your Name!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="*License Type"
                name="LicenseType"
                rules={[{ required: true, message: 'Please input your License Type!' }]}
              >
                <Select 
                  placeholder={t('membershipChild.UrgencyLevel')}
                  allowClear
                >
                  {LicenseList.map((item, index) => (
                    <Option key={index} value={item.value}>{item.label}</Option>
                ))}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="*License Number"
                name="LicenseNumber"
                rules={[{ required: true, message: 'Please input your License Number!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item            
                label="*State"
                name="State"
                rules={[{ required: true, message: 'Please input your State!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="*city"
                name="city"
                rules={[{ required: true, message: 'Please input your License city!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="*Apt,Suite,Building"
                name="Building"
                rules={[{ required: true, message: 'Please input your License Apt,Suite,Building!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} sm={12} md={8}>
              <Form.Item            
                label="*Email"
                name="Email"
                rules={[{ required: true, message: 'Please input your Email!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8}>
              <Form.Item
                label="*Phone"
                name="phone"
                rules={[{ required: true, message: 'Please input your License phone!' }]}
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};

export default EngineerZone; 